import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function to12(t) {
  if (!t) return "";
  let [h, m] = t.split(":").map(Number);
  const ap = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${String(m).padStart(2, "0")} ${ap}`;
}

/** Dropdown of open, available handoff appointment times for a given local date —
 * backed by GET /api/schedule/slots so the customer/admin can never pick a time the
 * backend would reject. Clears the selected value if it falls outside the day's open
 * slots (date changed, or an admin block removed that time). */
export function SlotPicker({ date, value, onChange, testid, className }) {
  const [slots, setSlots] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!date) { setSlots(null); return; }
    setLoading(true);
    axios.get(`${API}/schedule/slots?date=${date}`)
      .then((r) => setSlots(r.data.slots || []))
      .catch(() => setSlots([]))
      .finally(() => setLoading(false));
  }, [date]);

  useEffect(() => {
    if (slots && value && !slots.includes(value)) onChange("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slots]);

  const sel = className || "w-full bg-black border border-white/15 rounded-md px-3 py-2.5 text-white text-sm disabled:opacity-50";

  if (!date) return <select disabled data-testid={testid} className={sel}><option>Pick a date first</option></select>;
  if (loading) return <select disabled data-testid={testid} className={sel}><option>Loading times…</option></select>;
  if (slots && slots.length === 0) return (
    <div data-testid={`${testid}-none`} className="text-red-400 text-xs py-2.5 px-1">
      No appointment times are open that day — please pick a different date.
    </div>
  );

  return (
    <select data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} className={sel}>
      <option value="">Select an appointment time…</option>
      {(slots || []).map((s) => <option key={s} value={s}>{to12(s)}</option>)}
    </select>
  );
}
